import { Container, Row, Col } from "react-bootstrap";
import img1 from "../../../assets/DigitalMarketing/image/appoinment/image 1.png";
import mail from "../../../assets/DigitalMarketing/image/appoinment/mail.svg";
import call from "../../../assets/DigitalMarketing/image/appoinment/call.svg";
import logo from "../../../assets/DigitalMarketing/image/appoinment/Logo.svg";
import date from "../../../assets/DigitalMarketing/image/event.svg";
import circle from "../../../assets/DigitalMarketing/image/appoinment/Rectangle 40488.svg";

function AppoinmentConfirm(props) {
  const { details, register } = props;
  return (
    <>
      <div className="landing-layout">
        <Row>
          <Col lg={5} className="p-3">
            <div>
              <img className="landing-img" src={details?.templateImage} />
            </div>
          </Col>
          <Col lg={7} className="p-3">
            <Row className="Confirm-layout">
              <div className="landing-layout1">
                <Row>
                  <Col lg={12}>
                    <h5 className="landing-headSuccess">
                      Thanks For Your Submission! Our Team will Contact You
                      Shortly
                    </h5>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} className="center">
                    <div>
                      <div className="mb-2">
                        <label className="landing-label">Patient Name</label>
                        <p>{register?.customerName}</p>
                      </div>
                      <div className="mb-2">
                        <label className="landing-label">Mobile Number</label>
                        <p>{register?.phoneNumber}</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="frame-layout">
                <Row>
                  <Col lg={2}>
                    <div className="d-flex">
                      <img src={details?.hospitalImage} className="circle-img" alt="circle" />
                      <h5 className="landing-headConfirm hide mx-2 mt-3">
                        {details?.hospitalName}
                      </h5>
                    </div>
                  </Col>
                  <Col lg={10} md={10} className="ps-4">
                    <h5 className="landing-headConfirm show">
                      {details?.hospitalName}
                    </h5>
                    <small className="landing-bodyConfirm">
                      {details?.address}
                    </small>
                    <div className="mt-3 mb-3 d-flex">
                      <img className="login-logo mt-1" src={mail} alt="mail" />
                      <span>
                        <small className="landing-mailConfirm">
                          {details?.emailId}
                        </small>
                      </span>
                      &nbsp; &nbsp;
                      <img className="login-logo mt-1" src={call} alt="call" />
                      <span>
                        <small className="landing-mailConfirm">
                          {details?.mobileNo}
                        </small>
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="footer mb-3 mt-3">
        <div className="d-flex justify-content-center mt-5">
          <div className="landing-logo">
            <img src={logo} />
          </div>
        </div>
      </div>
    </>
  );
}

export default AppoinmentConfirm;
